import { useMutation } from "@tanstack/react-query";
import { shareContent } from "../api/content.api";
import { useToast } from "./ToastContext";

export const useShareContent = () => {
  const { showToast } = useToast();

  const { mutate: share, isPending } = useMutation({
    mutationFn: shareContent,
    onSuccess: () => {
      showToast("Content shared", "success");
    },
    onError: (err: Error) => {
      console.error("Error sharing content:", err);
      showToast(err.message || "Failed to share content", "error");
    },
  });

  return { share, isPending };
};

